import { Component } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'app-auth-error',
  templateUrl: './auth-error.component.html',
  styleUrls: ['./auth-error.component.scss']
})
export class AuthErrorComponent{

	constructor(private router: Router) {}

	reloadPage() {
		this.router.navigate(['/']);
	}
}